import Validator from "Validation/Validator";

export default class EmailValidator implements Validator<string> {
    constructor(readonly errorMessage = "Please enter a valid email address") { }

    isValid(value: string | null | undefined): boolean {
        if (value === null || value === undefined || value === "") return true; // Use FieldIsRequiredValidator for required check
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
    }
}
